// widok pozycji w wersji small dla desktop (oryginalna wersja bez zmian mobile)

import React from 'react';
import { Trans } from 'react-i18next';
import { Trash } from 'react-bootstrap-icons';

import { ICartPositionListItem } from 'api/types';
import { IColumn } from 'components/controls/Table';
import { Availability, Link } from 'components/controls';

import QuantityWrapper from 'components/containers/CartPositions/components/QuantityWrapper';

import styles from 'theme/components/containers/CartPositions/CartPositions.module.scss';
import classNames from 'classnames';
import counterStyles from 'theme/components/controls/Counter/Counter.module.scss';
import { hasSpecialPriceLabel } from 'utils/productHelpers';

import serviceIcon from 'assets/images/service-circle.png';

export const getSmallColumnsDesktop = ({
  cartId,
  onChange,
  queryParams,
  setItemsToRemove,
  cartPositions
}: {
  cartId: number;
  onChange?: () => void;
  queryParams: object;
  updatingPositionIds: number[];
  setItemsToRemove: (items: ICartPositionListItem[]) => void;
  cartPositions: ICartPositionListItem[];
}): IColumn<ICartPositionListItem>[] => {
  const cartServicesAsPositions = cartPositions
    .map((value) => {
      if (value.type === 'service') {
        return value.id;
      }
    })
    .filter((item) => !!item);

  return [
    {
      title: '',
      key: 'product-image',
      renderCell: (item) => {
        const isCartService = cartServicesAsPositions.includes(item.id);
        return (
          <div className={styles.productThumb}>
            {isCartService ? (
              <img src={serviceIcon} alt={item.name} />
            ) : (
              <Link to={`/${item.url_link}`}>
                <img src={item.image[0]?.thumb} alt={item.name} />
              </Link>
            )}
          </div>
        );
      },
      width: 78
    },
    {
      title: <Trans>Nazwa produktu</Trans>,
      dataIndex: 'name',
      align: 'left',
      renderCell: (item) => {
        const isCartService = cartServicesAsPositions.includes(item.id);
        return (
          <div className={styles.productInfo}>
            {isCartService ? (
              <span>{item.name}</span>
            ) : (
              <>
                <Link to={`/${item.url_link}`}>{item.name}</Link>
                <div className={styles.grey}>{item.index}</div>
                <Availability stock={item.stock} units={item.units} source={item} />
              </>
            )}
          </div>
        );
      }
    },
    {
      title: <Trans>Ilość</Trans>,
      dataIndex: 'quantity',
      align: 'center',
      width: 160,
      renderCell: (item) => {
        const isCartService = cartServicesAsPositions.includes(item.id);
        return (
          <div className={styles.quantityCellWrapper}>
            {isCartService ? (
              <div
                className={classNames(
                  counterStyles.componentWrapper,
                  null,
                  'StylePath-Components-Controls-Counter'
                )}
              >
                <input
                  className={counterStyles.input}
                  value={item.quantity}
                  disabled={true}
                />
              </div>
            ) : (
              <QuantityWrapper
                cartId={cartId}
                item={item}
                onChange={onChange}
                queryParams={queryParams}
              />
            )}
          </div>
        );
      }
    },
    {
      title: <Trans>Wartość</Trans>,
      dataIndex: 'total_price_net',
      align: 'right',
      renderCell: (item) => (
        <div className={styles.productTotalPrice}>
          <span
            className={classNames({
              [styles.priceNetBlue]: hasSpecialPriceLabel(item as { price_label?: string })
            })}
          >
            {item.total_price_net_formatted} {item.currency}{' '}
            <span className={styles.suffix}>
              <Trans>netto</Trans>
            </span>
          </span>
          <div className={styles.small}>
            <span
              className={classNames({
                [styles.priceNetBlue]: hasSpecialPriceLabel(item as { price_label?: string })
              })}
            >
              {item.total_price_gross_formatted} {item.currency}{' '}
              <span className={styles.suffix}>
                <Trans>brutto</Trans>
              </span>
            </span>
          </div>
        </div>
      )
    },
    {
      title: <Trans>Opcje</Trans>,
      key: 'actions',
      align: 'center',
      renderCell: (item) => {
        const isCartService = cartServicesAsPositions.includes(item.id);
        return (
          <div className={styles.actionsWrapper}>
            {!isCartService && <Trash onClick={() => setItemsToRemove([item])} />}
          </div>
        );
      }
    }
  ];
};

